import type { CoachingPlan } from '@efdigital/ll-addon-data';
import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import { cacheKeyFor, type Store } from '@warp-drive/core';
import { query } from '@warp-drive/utilities/json-api';
import { createRecord } from '@warp-drive/utilities/json-api';

import { jsonApiOptions, page } from '../../json-api.ts';

export function queryCoachingPlanByCoachee(
  coacheeUserId: string,
  coachingId: string
) {
  return query<CoachingPlan>(
    DataTypeCoaching.CoachingPlan,
    {
      'filter[user]': coacheeUserId,
      'filter[coaching.id]': coachingId,
      ...page({ offset: 0, limit: 1 }),
    },
    jsonApiOptions
  );
}

export function createCoachingPlan(coachingPlan: CoachingPlan, store: Store) {
  const init = createRecord(coachingPlan, {
    ...jsonApiOptions,
  });

  init.body = JSON.stringify({
    data: store.cache.peek(cacheKeyFor(coachingPlan)),
  });

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}
